import LoginForm from "../organisms/login/LoginForm";

const LogTemplate = () => {
    return(
        <div className="w-full h-screen grid place-content-center bg-gradient-to-b from-rs-azul via-gray-400 to-white ">
            <LoginForm/>
        </div>
    );
};

export default LogTemplate;